<div #wrapperEl class="snackbar-top-layer" popover="manual">
  <kc-snackbar />
</div>
